import type { HttpHandler } from 'msw';

import { handlers as featuresHandlers } from './features/handlers';
import { handlers as fleetVerificationHandlers } from './fleet-verification/handlers';
import { handlers as legalDocumentsHandlers } from './legal-documents/handlers';
import { handlers as refDataHandlers } from './refData/handlers';
import { handlers as segmentHandlers } from './segment/handlers';
import { handlers as smartyHandlers } from './smarty/handlers';

const handlers: HttpHandler[] = [
  ...segmentHandlers,
  ...refDataHandlers,
  ...smartyHandlers,
  ...featuresHandlers,
  ...fleetVerificationHandlers,
  ...legalDocumentsHandlers,
];

export { handlers };
